var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("input", {
        ref: "input",
        staticClass: "d-none",
        attrs: { type: "file" },
        on: { change: _vm.onChange },
      }),
      _vm._v(" "),
      _vm._t(
        "default",
        function () {
          return [
            _c("button", { staticClass: "btn btn-purple" }, [
              _vm._v("Select a file"),
            ]),
          ]
        },
        { clickHandler: _vm.open }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }